import { useQuery } from '@tanstack/vue-query'
import { useHttp } from '@/shared/lib'

const useLoadTree = (parent_id?: number) => {
  const http = useHttp()
  const url = parent_id ? `/schedules/tree?parent_id=${parent_id}` : '/schedules/tree'

  return useQuery({
    queryKey: ['load_schedules_tree', parent_id || 'default'],
    queryFn: () => http.get(url),
    retry: false,
    enabled: false,
  })
}

export { useLoadTree }
